import { BrowserRouter, Routes, Route } from "react-router-dom";
import MindARThreeViewer from "./mindar-three-viewer";
import HomePage from "./HomePage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/:key" element={<MindARThreeViewer />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
